import response from "./response";
class Auth {
  static IsLogin(context) {
    return new Promise((resolve, reject) => {
      var _token = localStorage.getItem("token");
      if (_token != null) {
        context.$store
          .dispatch({
            type: "GetMemberAccessToken",
            token: _token
          })
          .then(res => {
            response.callNotMsgResponse(res, result => {
              if (result != null) {
                var nowDate = new Date();
                var expDate = new Date(result.tokenExp.replace(/\-/g, "/"));
                if (expDate.getTime() >= nowDate.getTime()) {
                  resolve(true);
                }
                else{
                  resolve(false);
                }
              }
              else{
                resolve(false);
              }
            });
          });
      } else {
        resolve(false);
      }
    });
  }
}

export default Auth;



// WEBPACK FOOTER //
// ./src/tools/auth.js